import { makeStyles } from "@material-ui/core/styles";

export default makeStyles((theme) => ({
  wapperunitCardItemSkeleton: {
    width: "305.5px",
    display: "flex",
    flexDirection: "column",
    [theme.breakpoints.down("xs")]: {
      width: "100%",
    },
  },
  containerImage: {
    width: "305.5px",
    height: "240px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    background: theme.palette.background.secondary_hover,
    [theme.breakpoints.down("xs")]: {
      width: "100%",
    },
  },
  containerBodyCard: {
    width: "305.5px",
    height: "240px",
    display: "flex",
    flexDirection: "column",
    gap: "16px",
    padding: "20px 16px",
    [theme.breakpoints.down("xs")]: {
      width: "100%",
    },
  },
  containerBottomSection: {
    display: "flex",
    flexDirection: "column",
    gap: "8px",
  },
  containerTopSection: {
    display: "flex",
    flexDirection: "column",
  },
  containerUnitPrice: {
    display: "flex",
    justifyContent: "space-between",
    flexDirection: "row",
  },
  containerPriceTitle: {
    display: "flex",
    gap: "8px",
    flexDirection: "row",
    alignItems: "center",
  },
  containerPrice: {
    fontSize: "20px",
    fontWeight: 600,
    lineHeight: "30px",
    color: theme.palette.text.brand_tertiary,
  },
  containerCustomCopyToBoard: {
    display: "flex",
    flexDirection: "row",
    gap: "8px",
  },
  containerUnitTypeAndCopy: {
    display: "flex",
    flexDirection: "row",
    gap: "10px",
  },
  containerInfoSection: {
    display: "flex",
    flexDirection: "row",
    gap: "8px",
    alignItems: "center",
  },
  detailsUnits: {
    display: "flex",
    flexDirection: "row",
    gap: "8px",
  },
  containerUnitItem: {
    display: "flex",
    flexDirection: "row",
    gap: "4px",
  },
}));
